import { render, staticRenderFns } from "./Erg.vue?vue&type=template&id=31c0a236&"
import script from "./Erg.vue?vue&type=script&lang=ts&"
export * from "./Erg.vue?vue&type=script&lang=ts&"
import style0 from "./Erg.vue?vue&type=style&index=0&id=31c0a236&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports